import logo from "../../assets/logo-assine.png";
import { Link as RouterLink } from "react-router-dom";
import React from "react";
import { Card, CardContent, Button } from "@material-ui/core";

export default function LandingPage() {
  return (
    <div style={{ background: "radial-gradient(circle at top, #1e6fff22, transparent 60%), #0b0f1a", minHeight: "100vh", color: "white", fontFamily: "Arial, sans-serif" }}>
      {/* Header */}
      <header style={{ maxWidth: 1100, margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center", padding: 20 }}>
       <img src={logo} alt="Logo" style={{ width: "200px" }} />
       
        <Button
          component={RouterLink}
          to="/signup"
          variant="contained"
          style={{ background: "#1e6fff", color: "#fff", borderRadius: 10 }}
        >
          Começar
        </Button>
      </header>

      {/* Hero */}
      <section style={{ maxWidth: 1100, margin: "40px auto", display: "flex", justifyContent: "space-between", gap: 40, alignItems: "center", padding: 10 }}>
        <div>
          <h1 style={{ fontSize: 42, marginBottom: 20, lineHeight: 1.2 }}>
            Toda sua equipe atendendo, um único WhatsApp 🚀
          </h1>

          <p style={{ color: "#9aa4c7", marginBottom: 25, fontSize: 16, lineHeight: 1.6 }}>
            Centralize seu atendimento, organize setores e responda clientes mais rápido com automação inteligente.
          </p>

          <Button
            component={RouterLink}
            to="/signup"
            variant="contained"
            style={{
              background: "#1e6fff",
              color: "#fff",
              padding: "12px 24px",
              fontSize: 16,
              borderRadius: 12,
              boxShadow: "0 0 20px rgba(30,111,255,0.4)",
            }}
          >
            🔥 Testar grátis agora
          </Button>

          <p style={{ marginTop: 10, fontSize: 13, color: "#6b7280" }}>
            Sem cartão • Acesso imediato
          </p>
        </div>

   
      </section>

      {/* Features */}
      <section style={{ maxWidth: 1100, margin: "80px auto", padding: 10 }}>
        <h2 style={{ fontSize: 32, marginBottom: 30 }}>Para quem é o WChat?</h2>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px,1fr))", gap: 20 }}>
          {[
            {
              title: "Saúde",
              desc: "Atendimento mais rápido e organizado para clínicas e hospitais.",
            },
            {
              title: "Ensino",
              desc: "Organize setores como financeiro e secretaria facilmente.",
            },
            {
              title: "Contabilidade",
              desc: "Controle demandas e comunicação do escritório.",
            },
            {
              title: "Advocacia",
              desc: "Automatize respostas e ganhe agilidade no atendimento.",
            },
            {
              title: "Imobiliária",
              desc: "Gerencie leads e equipe em um único número.",
            },
            {
              title: "Vendas",
              desc: "Integre atendimento, suporte e financeiro.",
            },
          ].map((item, i) => (
            <Card
              key={i}
              style={{
                background: "#4d8ee77a",
                border: "1px solid #1f2740",
                borderRadius: 12,
                padding: 10,
                transition: "0.3s",
                boxShadow: "0 0 20px rgba(30,111,255,0.4)",
                margin: "5",
              }}
            >
              <CardContent>
                <h3 style={{ marginBottom: 10, color: "#fff" }}>{item.title}</h3>
                <p style={{ color: "#9aa4c7", fontSize: 14 }}>{item.desc}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>

      {/* CTA Final */}
      <section style={{ textAlign: "center", marginBottom: 60 }}>
        <h2 style={{ fontSize: 28, marginBottom: 20 }}>
          Comece agora e organize seu atendimento 🚀
        </h2>
        <Button
          component={RouterLink}
          to="/signup"
          variant="contained"
          style={{ background: "#1e6fff", color: "#fff", padding: "14px 28px", borderRadius: 12 }}
        >
          Criar conta grátis
        </Button>
      </section>

      {/* Footer */}
      <footer style={{ textAlign: "center", color: "#6b7280", paddingBottom: 20 }}>
        © 2026 WChat - Todos os direitos reservados
      </footer>
    </div>
  );
}
